export const InquiryType = {
    Catering: "catering",
    LargeParty: "large_party",
    PrivateDining: "private_dining"
} as const

export const StyleOptions = [
    { value: "catering", label: "Full Service" }, 
    { value: "pickup", label: "Pick-Up" }
] as const

export const MembershipRole = {
    Admin: "admin",
    Member: "member"
} as const